export function responsiveCarousel(): void {


    // Set slides-per-page based on responsive CSS variable.

    let carousels = document.querySelectorAll('.product-carousel sl-carousel, .carousel-hero sl-carousel');

    if (carousels.length == 0)
        return;

    setSlidesProperties();

    window.addEventListener('resize', () => {
        setSlidesProperties();
    });

    function setSlidesProperties() {
        let lg = window.matchMedia("(width >= 768px)");

        carousels.forEach( (carousel) => {

            if (carousel != null) { 
                const slidesPerPage = window.getComputedStyle(carousel).getPropertyValue('--slides-per-page').replace(/"/g, '');

                if (slidesPerPage) {
                    carousel!.setAttribute('slides-per-page', slidesPerPage);
                    carousel!.setAttribute('slides-per-move', slidesPerPage);
                }
                const htmlCarousel = carousel as HTMLElement;
                let aspectRatio = htmlCarousel.dataset.aspectRatioMobile;
                if (lg.matches) {
                    aspectRatio = htmlCarousel.dataset.aspectRatio;
                }

                if (aspectRatio) {
                    
                    console.log("aspectRatio: " + aspectRatio);
                    htmlCarousel!.style.setProperty("--aspect-ratio", aspectRatio);
                }
            }
        });
    }

}
/*
https://github.com/shoelace-style/shoelace/discussions/1595
#product-carousel {
  --slides-per-page: 1;
}

@media (min-width: 45em) {
  #product-carousel {
    --slides-per-page: 2;
  }
}

@media (min-width: 60em) {
  #product-carousel {
    --slides-per-page: 3;
  }
}




*/